import React from 'react';
import { Router, browserHistory } from 'react-router'

export default class trigger extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            SelectElements: [],
            element: {},
            type: "value"
        }
        this.renderTrigger = this.renderTrigger.bind(this);
        this.renderCondition = this.renderCondition.bind(this);
        this.renderOptionValue = this.renderOptionValue.bind(this);
    }

    componentWillMount() {
        var array = [];
        var obj = {};
        Object.values(this.props.elements).map((f) => {
            Object.values(f.elements).map((e, index) => {
                if (e.element_id == "CHECKBOX" || e.element_id == "INPUT" || e.element_id == "DROPDOWNLIST"
                    || e.element_id == "RADIO_BUTTON" || e.element_id == "BUTTONGROUP") {
                    array.push({
                        value: e,
                        text: e.id
                    })
                }
            });
        });
        this.setState({ SelectElements: array });
    }

    setTypeElement(element) {
        var type;
        Object.values(this.props.elements).map((f) => {
            Object.values(f.elements).map((e, index) => {
                if (e.id === element) {
                    type = e.element_id;
                    this.state.element = e;
                }
            });
        });
            return type;
        }

    renderCondition() {
                var element_id = this.setTypeElement(this.state.trigger);
                switch(element_id) {
            case "DROPDOWNLIST":
                return(
                    <label htmlFor = "name" > Es seleccionado</label>
                );
                break;
                case "INPUT":
                return(
                    <select className = "form-control" id = "ccmonth" onClick = {(e) => this.setState({ condition: e.target.value })} >
            <option value="" defaultValue hidden>Seleccione una opcion</option>
            <option value="eq">Igual que</option>
            <option value="neq">Distinto a</option>
            <option value="gt">Mayor que</option>
            <option value="gte">Mayor o igual que</option>
            <option value="lt">Menor que</option>
            <option value="lte">Menor o igual que</option>
                    </select >
                );
        break;
            case "CHECKBOX":
        return (
            <select className="form-control" id="ccmonth" onClick={(e) => this.setState({ condition: e.target.value })}>
                <option value="" defaultValue hidden>Seleccione una opcion</option>
                <option value="eq" >Igual que</option>
                <option value="neq" >Distinto a</option>
            </select>
        );
        break;
            case "RADIO_BUTTON":
        return (
            <select className="form-control" id="ccmonth" onClick={(e) => this.setState({ condition: e.target.value })}>
                <option value="" defaultValue hidden>Seleccione una opcion</option>
                <option value="eq" >Igual que</option>
                <option value="neq" >Distinto a</option>
            </select>
        );
        break;
            case "BUTTONGROUP":
        return (
            <select className="form-control" id="ccmonth" onClick={(e) => this.setState({ condition: e.target.value })}>
                <option value="" defaultValue hidden>Seleccione una opcion</option>
                <option value="eq" >Igual que</option>
                <option value="neq" >Distinto a</option>
            </select>
        );
        break;
            default:
        return (
            <label htmlFor="name">Seleccione un elemento</label>
        );
    break;
}
    }

renderOptionValue() {
    var element_id = this.setTypeElement(this.state.trigger);
    switch (element_id) {
        case "BUTTONGROUP":
            return (
                <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ value: e.target.value, type: "element_id" }) }}>
                    <option value="" defaultValue hidden>Seleccione una opcion</option>
                    {this.state.element.childrens.map((c) => (
                        <option value={c.value}>{c.text}</option>
                    ))}
                </select>
            );
        case "CHECKBOX":
            return (
                <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ value: e.target.value === "true" ? true : false, type: "value" }) }}>
                    <option value="" defaultValue hidden>Seleccione una opcion</option>
                    <option value={true} >true</option>
                    <option value={false}>false</option>
                </select>
            );
        case "INPUT":
            return (
                <div className="form-group">
                    <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ type: e.target.value }) }}>
                        <option value="" defaultValue hidden>Seleccione una opcion</option>
                        <option value="element_id">Otro Elemento</option>
                        <option value="value">Insertar Valor</option>
                    </select>
                    <hr />
                    {
                        this.state.type ?
                            this.state.type === "element_id" ?
                                <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ value: e.target.value, type: "element_id" }) }}>
                                    <option value="" defaultValue hidden>Seleccione un Elemento</option>
                                    {
                                        this.state.SelectElements.map((e) => (
                                            <option value={e.value.id}>{e.text}</option>
                                        ))
                                    }
                                </select>
                                :
                                <div className="form-group">
                                    <label htmlFor="name">Valor:</label>
                                    <input type="text" className="form-control" value={this.state.value} placeholder="Ingrese valor" onChange={(e) => { this.setState({ value: e.target.value, type: "value" }) }} />
                                </div>
                            :
                            ""
                    }
                </div>
            );
        default:
            return (
                ""
            );
    }
}

renderTrigger() {
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="form-group row">
                    <div className="col-md-4">
                        <label htmlFor="name">El valor de:</label>
                        <select className="form-control" id="ccmonth" onChange={(e) => { this.setState({ trigger: e.target.value }) }}>
                            <option value="" defaultValue hidden>Seleccione un Elemento</option>
                            {
                                this.state.SelectElements.map((e) => (
                                    <option value={e.value.id}>{e.text}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="name">Condición:</label>
                        {this.state.trigger ? this.renderCondition() : ""}
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="name">Comparado con:</label>
                        {this.renderOptionValue()}
                    </div>
                </div>
            </div>
        </div>
    );
}

render() {
    var obj = {};
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="card card-outline-success mb-3">
                    <div className="card-block">
                        <blockquote className="card-blockquote">
                            <div className="form-group row">
                                <div className="col-md-10">
                                    {this.renderTrigger()}
                                </div>
                                <div className="col-md-2">
                                    {
                                        this.state.done !== true ?
                                            <button style={{ marginTop: "28px" }} onClick={() => { obj = { condition: this.state.condition, [this.state.type]: this.state.value }; this.props.callBack(obj, this.state.trigger); this.setState({ done: true }) }} type="button" className="btn btn-outline-primary">Añadir</button>
                                            : ""
                                    }
                                </div>
                            </div>
                        </blockquote>
                    </div>
                </div>
            </div>
        </div >
    );
};
}


// WEBPACK FOOTER //
// ./src/views/functions/trigger.js